import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { PublicStakeholderDTO } from 'src/app/features/subscription/types/PublicStakeholderDTO';
import { environment } from 'src/environments/environment';
import { HttpOptions } from '../types/HttpOptions';
import { StakeholderDto } from '../types/StakeholderDto';

const DEFAULT_OPTIONS = {
  headers: new HttpHeaders({
    accept: '*/*',
  }),
} satisfies HttpOptions;

@Injectable({
  providedIn: 'root',
})
export class StakeholderService {
  private _options = DEFAULT_OPTIONS;

  private _isRevalidating$ = new BehaviorSubject(false);
  /**
   * Global observable for tracking whether the client
   * is awaiting a fetch call for 'getStakeholderFromGuid'.
   */
  public isRevalidating$ = this._isRevalidating$.asObservable();

  constructor(private http: HttpClient) {}

  postCreateStakeholderForProject(
    projectGuid: string,
    body: StakeholderDto
  ): Observable<StakeholderDto> {
    if (body.IsReceiveEmailUpdate === undefined) {
      body.IsReceiveEmailUpdate = false;
    }
    return this.http
      .post<StakeholderDto>(
        `${environment.ApiUrl}/Stakeholder/CreateStakeholder/${projectGuid}`,
        body,
        this._options
      )
      .pipe(
        tap({
          error: (error) => {
            console.error('Error create stakeholder by guid:', error);
          },
        })
      );
  }

  findStakeholderByInfo(
    lastName: string,
    zipCode: string,
    email: string
  ): Observable<PublicStakeholderDTO> {
    return this.http
      .get<PublicStakeholderDTO>(
        `${environment.ApiUrl}/Stakeholder/FindStakeholder/${lastName}/${zipCode}/${email}`,
        this._options
      )
      .pipe(
        tap({
          error: (error) => {
            console.error('Error find stakeholder by info', error);
          },
        })
      );
  }

  getBlankStakeholder(projectGuid: string): Observable<PublicStakeholderDTO> {
    return this.http
      .get<PublicStakeholderDTO>(
        `${environment.ApiUrl}/Stakeholder/GetBlankStakeholder/${projectGuid}`,
        this._options
      )
      .pipe(
        tap({
          error: (error) => {
            console.error('Error get blank stakeholder', error);
          },
        })
      );
  }

  getAnonymousStakeholder(): Observable<{ StakeGuid: string }> {
    const headers = new HttpHeaders({
      accept: '*/*',
    });
    const options = { headers: headers };

    return this.http
      .get<{ StakeGuid: string }>(`${environment.ApiUrl}/Stakeholder/GetAnonStakeholder`, options)
      .pipe(
        tap({
          error: (error) => {
            console.error(error);
          },
        })
      );
  }
}
